import { GlButton } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { TYPE_ISSUE, TYPE_MERGE_REQUEST } from '~/issues/constants';
import { __, sprintf } from '~/locale';
import AssigneeAvatarLink from '/builds/gitlab/gitlab-ee/app/assets/javascripts/sidebar/components/assignees/assignee_avatar_link.vue?vue3';
import UserNameWithStatus from '/builds/gitlab/gitlab-ee/app/assets/javascripts/sidebar/components/assignees/user_name_with_status.vue?vue3';
const DEFAULT_RENDER_COUNT = 5;
export default {
    name: 'UncollapsedAssigneeList',
    components: {
        GlButton,
        AssigneeAvatarLink,
        UserNameWithStatus
    },
    props: {
        users: {
            type: Array,
            required: true
        },
        issuableType: {
            type: String,
            required: false,
            default: TYPE_ISSUE
        }
    },
    data () {
        return {
            showLess: true
        };
    },
    computed: {
        hiddenAssigneesLabel () {
            const { numberOfHiddenAssignees } = this;
            return sprintf(__('+ %{numberOfHiddenAssignees} more'), {
                numberOfHiddenAssignees
            });
        },
        renderShowMoreSection () {
            return this.users.length > DEFAULT_RENDER_COUNT;
        },
        numberOfHiddenAssignees () {
            return this.users.length - DEFAULT_RENDER_COUNT;
        },
        uncollapsedUsers () {
            const uncollapsedLength = this.showLess ? Math.min(this.users.length, DEFAULT_RENDER_COUNT) : this.users.length;
            return this.showLess ? this.users.slice(0, uncollapsedLength) : this.users;
        }
    },
    methods: {
        toggleShowLess () {
            this.showLess = !this.showLess;
        },
        userAvailability (u) {
            if (this.issuableType === TYPE_MERGE_REQUEST) {
                return u?.availability || '';
            }
            return u?.status?.availability || '';
        }
    }
};
